// Generated by CoffeeScript 2.7.0
var Field, SerialNumberBaseModel;

SerialNumberBaseModel = class SerialNumberBaseModel extends Skylark.App.Model.Field.Base {};

Field = {
  FormFields: SerialNumberBaseModel,
  RadioButton: SerialNumberBaseModel,
  DateTime: SerialNumberBaseModel,
  'Number': SerialNumberBaseModel,
  ConstText: SerialNumberBaseModel,
  ProposeTime: SerialNumberBaseModel,
  Proposer: SerialNumberBaseModel
};

SerialNumberBaseModel.constantize = function(field_type) {
  return Field[field_type.demodulize()] || (function() {
    throw `Invalid field_type: ${field_type}`;
  })();
};

SerialNumberBaseModel.new = function(attrs, fieldable) {
  var model;
  if (attrs instanceof this) {
    attrs.fieldable = fieldable;
    return attrs;
  } else {
    model = SerialNumberBaseModel.constantize(attrs.type);
    return new model(attrs, fieldable);
  }
};

export default SerialNumberBaseModel;
